import ReactDOM, {unmountComponentAtNode} from 'react-dom';
import {Provider} from 'react-redux';
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
/* Config */
import {initStore, destroyStore} from './store/store';
/* Components */
import App from './app';
/* Styles */
import './assets/fonts/g-icons/glu-font-icons.scss';
import './assets/fonts/oxygen/font-oxygen.scss';
import './index.scss';
import 'rc-tooltip/assets/bootstrap.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import 'react-notifications-component/dist/theme.css';

const APP_ID = 'gluware-react-app';
window.startReactApp = () => {
  const appElement = document.getElementById(APP_ID);
  const store = initStore();

  if (appElement) {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      appElement
    );
  }
};

window.stopReactApp = () => {
  const appElement = document.getElementById(APP_ID);
  if (appElement) {
    unmountComponentAtNode(appElement);
    destroyStore();
  }
};
